import React, { useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import $ from "jquery";
import "../../resources/js/jquery.rwdImageMaps.js";
import "../../resources/css/landing.css";

const AnimationIbosa = () => {
  const player_pc = useRef(null);
  const player_tb = useRef(null);
  const player_mo = useRef(null);

  useEffect(() => {
    // jQuery rwdImageMaps 초기화
    $("img[usemap]").rwdImageMaps();

    // YouTube iframe API 로딩
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    // YouTube iframe API가 준비되면 호출되는 함수
    window.onYouTubeIframeAPIReady = () => {
      player_pc.current = new window.YT.Player("u_player", {
        height: "700",
        width: "1000",
        videoId: "gsF1D1qppGA",
      });
      player_tb.current = new window.YT.Player("t_player", {
        height: "560",
        width: "780",
        videoId: "gsF1D1qppGA",
      });
      player_mo.current = new window.YT.Player("m_player", {
        height: "350",
        width: "480",
        videoId: "gsF1D1qppGA",
      });
    };

    // 클린업: 컴포넌트가 언마운트 될 때 iframe API와 관련된 작업 정리
    return () => {
      window.onYouTubeIframeAPIReady = null;
    };
  }, []);

  const play = (player, popupClass) => {
    $(`.${popupClass}, .ibosa_modal`).css("display", "block");

    const win_width = window.innerWidth;
    const popup_width =
      player === player_pc ? 1000 : player === player_tb ? 780 : 480;
    const cen_left = win_width / 2 - popup_width / 2;

    const win_height = window.innerHeight;
    const popup_height =
      player === player_pc ? 700 : player === player_tb ? 550 : 350;
    const scr_top = $(window).scrollTop();
    const cen_top = scr_top + (win_height / 2 - popup_height / 2);

    $(`#${popupClass}`).css("left", cen_left);
    $(`#${popupClass}`).css("top", cen_top);

    // Visibility 대신 display: block 으로 바꿔서 요소를 보이도록 설정
    $(`#${popupClass}`).css("visibility", "visible");
    player.playVideo();
  };

  const resetVideo = (player, popupClass) => {
    // 팝업을 숨기기
    $(`.${popupClass}, .ibosa_modal`).css("display", "none");

    // 팝업 요소에 접근할 때 document.getElementById() 사용
    const popupElement = document.getElementById(popupClass);

    if (popupElement) {
      popupElement.style.visibility = "hidden"; // visibility를 hidden으로 설정
    }

    player.stopVideo(); // 비디오 정지
  };

  return (
    <div>
	<Helmet>
	  <title>마법여우 주비</title>
	  <meta property="og:locale" content="ko_KR" />
	  <meta property="og:type" content="website" />
	  <meta property="og:title" content="아소비 애니메이션" />
	  <meta property="og:description" content="마법여우 주비" />
	  <meta
	    property="og:image"
	    content="https://spring.asobi.co.kr/custom-resources/img/Joobi_preview.png"
	  />
	  <meta
	    property="og:url"
	    content="https://spring.asobi.co.kr/landing/animation_ibosa"
	  />
	</Helmet>
      <div className="ibosa_modal"></div>
      <div id="section01" className="landing-pc-view">
        <img
          className="ibosaimg"
          src="../../custom-resources/img/Joobi2Landingv7.png"
          alt=""
          border="0"
          usemap="#joobi_ibosa"
        />
        <map name="joobi_ibosa" id="joobi_ibosa">
          <area
            shape="rect"
            target="_blank"
            coords="731,3065,1187,3142"
            href="https://forms.gle/3Ke1i64yZNK8WLUU6"
            alt="jobi_ibosa_forms"
          />
          <area
            shape="rect"
            coords="558,3935,1354,4375"
            alt="jobi_ibosa_play"
            onClick={() => play(player_pc.current, "movie_pop_pc")}
            style={{ cursor: "pointer" }}
          />
        </map>
      </div>

      <div id="section01" className="landing-tb-view">
        <img
          className="ibosaimg"
          src="../../custom-resources/img/Joobi2Landingv7_mo.png"
          alt=""
          border="0"
          usemap="#joobi_ibosa_tb"
        />
        <map name="joobi_ibosa_tb" id="joobi_ibosa_tb">
          <area
            shape="rect"
            target="_blank"
            coords="300,3065,760,3144"
            href="https://forms.gle/3Ke1i64yZNK8WLUU6"
            alt="jobi_ibosa_forms"
          />
          <area
            shape="rect"
            coords="130,3920,936,4368"
            alt="jobi_ibosa_play"
            onClick={() => play(player_tb.current, "movie_pop_tb")}
            style={{ cursor: "pointer" }}
          />
        </map>
      </div>

      <div id="section01" className="landing-mo-view">
        <img
          className="ibosaimg"
          src="../../custom-resources/img/Joobi2Landingv7_mo.png"
          alt=""
          border="0"
          usemap="#joobi_ibosa_mo"
        />
        <map name="joobi_ibosa_mo" id="joobi_ibosa_mo">
          <area
            shape="rect"
            target="_blank"
            coords="300,3065,760,3144"
            href="https://forms.gle/3Ke1i64yZNK8WLUU6"
            alt="jobi_ibosa_forms"
          />
          <area
            shape="rect"
            coords="130,3920,936,4368"
            alt="jobi_ibosa_play"
            onClick={() => play(player_mo.current, "movie_pop_mo")}
            style={{ cursor: "pointer" }}
          />
        </map>
      </div>

      <div className="movie_pop_pc">
        <div id="divpopup_pc">
          <div id="u_player"></div>
          <div className="divpopup_form clearfix">
            <div className="divpopup_close">
              <a onClick={() => resetVideo(player_pc.current, "movie_pop_pc")}>
                <span>[닫기]</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="movie_pop_tb">
        <div id="divpopup_tb">
          <div id="t_player"></div>
          <div className="divpopup_form clearfix">
            <div className="divpopup_close">
              <a onClick={() => resetVideo(player_tb.current, "movie_pop_tb")}>
                <span>[닫기]</span>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="movie_pop_mo">
        <div id="divpopup_mo">
          <div id="m_player"></div>
          <div className="divpopup_form clearfix">
            <div className="divpopup_close">
              <a onClick={() => resetVideo(player_mo.current, "movie_pop_mo")}>
                <span>[닫기]</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnimationIbosa;
